<template lang="pug">
  div(class="m-block-activate-premium")
    div(class="text-12px fw-300 pb-2") {{ $t('Try Premium 14 days for free') }}
    v-btn(
      class="outlined-button w-100"
      @click="showPremiumFeaturesModal"
    ) {{ $t('Activate premium') }}
</template>

<script>
import premiumPlan from '~/mixins/plans/premiumPlan'
export default {
  name: 'MBlockActivatePremium',
  mixins: [premiumPlan]
}
</script>

<style scoped lang="scss">
.m-block-activate-premium {
  border-radius: 12px;
  border: 1px solid $white;
  background: url('~/assets/images/billing-progress-bg.png') lightgray 50% / cover no-repeat;
  padding: 12px;
}
</style>
